import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "header-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = {
  key: 0,
  class: "info-wrapper parents-chat pa-2 ma-2 autolinked",
  style: {"white-space":"pre-line"}
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "chat-wrapper pa-2 ma-2 tap-on"
}
const _hoisted_7 = {
  class: "autolinked",
  style: {"white-space":"pre-line","color":"primary"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "d-flex flex-column align-self-end pb-2" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "grey--text text-caption" }
const _hoisted_13 = {
  key: 1,
  class: "d-flex justify-end align-center reative"
}
const _hoisted_14 = { class: "grey--text text-caption align-self-end pb-2" }
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "align-self-end" }
const _hoisted_18 = {
  key: 0,
  class: "chat-wrapper staff-chat pa-2 ma-2 group-chat no-tap",
  style: {"user-select":"none"}
}
const _hoisted_19 = { class: "autolinked" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 1,
  oncontextmenu: "return false;",
  class: "chat-wrapper staff-chat pa-2 ma-2 no-tap",
  style: {"white-space":"pre-line","user-select":"none"}
}
const _hoisted_22 = {
  key: 0,
  class: "autolinked"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 1,
  class: "autolinked",
  style: {"pointer-events":"none"}
}
const _hoisted_25 = { class: "input-wrapper pa-1" }
const _hoisted_26 = {
  key: 0,
  class: "primary--text font-weight-bold"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "d-flex justify-space-around mb-3 mt-3" }
const _hoisted_29 = { class: "d-flex justify-space-around mb-3 mt-3" }
const _hoisted_30 = { class: "d-flex justify-space-around mb-3 mt-3" }
const _hoisted_31 = { class: "d-flex justify-space-around pt-3 pb-3" }
const _hoisted_32 = {
  key: 0,
  class: "d-flex px-3"
}
const _hoisted_33 = { class: "d-flex justify-space-around pt-3 pb-3" }
const _hoisted_34 = { class: "d-flex flex-column" }
const _hoisted_35 = { class: "pdf_header_wrapper" }
const _hoisted_36 = { class: "pdf" }
const _hoisted_37 = ["data"]
const _hoisted_38 = ["src"]
const _hoisted_39 = ["href"]
const _hoisted_40 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_DatePager = _resolveComponent("DatePager")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_MessageHandle = _resolveComponent("MessageHandle")!
  const _component_VueLoading = _resolveComponent("VueLoading")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_TranslationModal = _resolveComponent("TranslationModal")!
  const _component_AbsenceModal = _resolveComponent("AbsenceModal")!
  const _component_AbsenceDeleteModal = _resolveComponent("AbsenceDeleteModal")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_locale_provider = _resolveComponent("v-locale-provider")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[27] || (_cache[27] = () => ((_ctx.deleteArea = ''), (_ctx.actionDialog = false))),
    class: "no-tap"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_app_bar, {
        color: "primary",
        flat: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            style: {"position":"absolute"},
            icon: "mdi-chevron-left",
            to: '/'
          }),
          _createVNode(_component_v_spacer),
          (_ctx.child)
            ? (_openBlock(), _createBlock(_component_v_toolbar_title, {
                key: 0,
                style: {"min-width":"fit-content"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString((_ctx.child.lastName + ' ' + _ctx.child.firstName).length > 11
                ? (_ctx.child.lastName + ' ' + _ctx.child.firstName).slice(0, 11) + '…' 
                : _ctx.child.lastName + ' ' + _ctx.child.firstName), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            color: "primary",
            depressed: "",
            fab: "",
            onClick: _ctx.openSelectChildDialog,
            loading: _ctx.btnLoadingChat,
            height: "40",
            width: "40"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { color: "white" }, {
                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                  _createTextVNode(" mdi-arrow-down-drop-circle-outline ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick", "loading"]),
          (_ctx.chatComment)
            ? (_openBlock(), _createBlock(_component_v_badge, {
                key: 1,
                dot: "",
                color: "#E190CF",
                "offset-x": "8",
                "offset-y": "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_app_bar_nav_icon, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialog = true))
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
                key: 2,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialog = true))
              }))
        ]),
        _: 1
      }),
      (_ctx.isChatCreateUserMe)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            rounded: "0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openDateDialog && _ctx.openDateDialog(...args)))
              }, [
                _createVNode(_component_DatePager, {
                  date: _ctx.date,
                  onAddDay: _ctx.addDay,
                  onSubtractDay: _ctx.subtractDay,
                  isYear: false,
                  beforeTheDate: _ctx.unReadCount ? _ctx.unReadCount.beforeTheDate : 0,
                  afterTheDate: _ctx.unReadCount ? _ctx.unReadCount.afterTheDate : 0
                }, null, 8, ["date", "onAddDay", "onSubtractDay", "beforeTheDate", "afterTheDate"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_divider)
    ]),
    (!_ctx.fetchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "chat-area",
            onScroll: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tap()))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatPast, (chat, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "d-flex flex-column"
              }, [
                (chat.from)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_3, [
                        (chat.bodyType === 'absence' || chat.bodyType === 'pickup')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parseSegments(_ctx.translatedChats[chat.chatId] ?? chat.body), (seg, i) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                  (seg.type === 'url')
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        class: "highlights",
                                        style: {"cursor":"pointer","word-break":"break-all"},
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.urlClicked(seg.text))
                                      }, _toDisplayString(seg.text), 9, _hoisted_5))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(seg.text), 1)
                                      ], 64))
                                ], 64))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createElementVNode("p", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parseSegments(_ctx.translatedChats[chat.chatId] ?? chat.body), (seg, i) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                    (seg.type === 'url')
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "highlights",
                                          style: {"cursor":"pointer","word-break":"break-all"},
                                          href: "javascript:void(0)",
                                          onClick: ($event: any) => (_ctx.urlClicked(seg.text))
                                        }, _toDisplayString(seg.text), 9, _hoisted_8))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(seg.text), 1)
                                        ], 64))
                                  ], 64))
                                }), 128))
                              ])
                            ])),
                        _createElementVNode("div", _hoisted_9, [
                          (!_ctx.translatedChats[chat.chatId] && chat.bodyType === 'message')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_component_v_btn, {
                                  style: {"height":"18px","color":"#000000","border-color":"#000000","border-width":"1px"},
                                  onClick: ($event: any) => (_ctx.openTranslateDialog(chat))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { size: "small" }, {
                                      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                        _createTextVNode("mdi-google-translate", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.translatedChats[chat.chatId] && chat.bodyType === 'message')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_v_btn, {
                                  style: {"height":"16px","color":"#000000","border-color":"#000000","border-width":"1px"},
                                  onClick: ($event: any) => (_ctx.returnTranslate(chat.chatId))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { size: "small" }, {
                                      default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                        _createTextVNode("mdi-arrow-u-left-top", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatTime(chat.deliveredAt || chat.createdAt)), 1)
                        ])
                      ]),
                      (!chat.readAt)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            label: "",
                            color: "error",
                            variant: "outlined",
                            class: "pa-3 ml-2 mb-4",
                            style: {"width":"40%","z-index":"0"},
                            disabled: _ctx.btnLoadingChat,
                            onClick: ($event: any) => (_ctx.dblClick(chat))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { left: "" }, {
                                default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                  _createTextVNode("mdi-check", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[32] || (_cache[32] = _createTextVNode("確認する ", -1))
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]))
                        : _createCommentVNode("", true),
                      (chat.readAt)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 1,
                            label: "",
                            color: "",
                            variant: "outlined",
                            class: "pa-2 ml-2 mb-4",
                            style: {"width":"40%","z-index":"0"}
                          }, {
                            default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                              _createTextVNode(" 確認済み ", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (!chat.from)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          (chat.readAt)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, "既読"))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatTime(chat.deliveredAt || chat.createdAt)), 1)
                        ])
                      ]),
                      (chat.bodyType === 'groupChat')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", null, [
                              _cache[34] || (_cache[34] = _createElementVNode("p", { style: {"white-space":"pre-line"} }, _toDisplayString(`【連絡メール】\n`), -1)),
                              _createElementVNode("div", _hoisted_19, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parseSegments(chat.body), (seg, i) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                    (seg.type === 'url')
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "highlights",
                                          style: {"cursor":"pointer","word-break":"break-all"},
                                          href: "javascript:void(0)",
                                          onClick: ($event: any) => (_ctx.urlClicked(seg.text))
                                        }, _toDisplayString(seg.text), 9, _hoisted_20))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(seg.text), 1)
                                        ], 64))
                                  ], 64))
                                }), 128))
                              ])
                            ]),
                            _withDirectives(_createElementVNode("div", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chat.attachmentUrls, (au, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: au.objectKey
                                }, [
                                  (!_ctx.isPdf(au.objectKey))
                                    ? (_openBlock(), _createBlock(_component_v_card, {
                                        key: 0,
                                        onClick: ($event: any) => (_ctx.openChatImg(chat, index)),
                                        class: "pointer mt-1",
                                        style: {"min-width":"64vw"},
                                        elevation: "0"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_img, {
                                            src: au.url,
                                            contain: ""
                                          }, null, 8, ["src"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 1,
                                        class: "my-3",
                                        color: "primary",
                                        dark: "",
                                        variant: "text",
                                        size: "small",
                                        onClick: ($event: any) => (_ctx.openChatImg(chat, index)),
                                        loading: _ctx.imgLoading
                                      }, {
                                        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                          _createTextVNode(" 添付ファイルを表示する ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick", "loading"]))
                                ]))
                              }), 128))
                            ], 512), [
                              [_vShow, chat.attachmentUrls.length]
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            (_ctx.isLink(chat.body))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parseSegments(chat.body), (seg, i) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                      (seg.type === 'url')
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "highlights",
                                            style: {"cursor":"pointer","word-break":"break-all"},
                                            href: "javascript:void(0)",
                                            onClick: ($event: any) => (_ctx.urlClicked(seg.text))
                                          }, _toDisplayString(seg.text), 9, _hoisted_23))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(_toDisplayString(seg.text), 1)
                                          ], 64))
                                    ], 64))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(chat.body), 1))
                          ])),
                      _createVNode(_component_v_btn, {
                        icon: "",
                        variant: "plain",
                        onClick: ($event: any) => (_ctx.handleContentClick(chat, $event)),
                        small: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                              _createTextVNode("mdi-dots-vertical-circle-outline", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 32),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_v_divider, { class: "mb-2" }),
            (!_ctx.isChatCreateUserMe)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, "※閲覧のみ"))
              : _createCommentVNode("", true),
            _createVNode(_component_v_textarea, {
              variant: "outlined",
              modelValue: _ctx.inputText,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputText) = $event)),
              "auto-grow": "",
              rows: "1",
              "row-height": "15",
              "hide-details": "",
              density: "compact",
              class: "input-chat-area pa-0",
              color: "primary"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_MessageHandle, {
              onSaveDraft: _ctx.saveDraft,
              onSaveSendReady: _ctx.saveSendReady,
              onSendMessage: _ctx.sendMessage,
              btnSendLoading: _ctx.btnSendLoading,
              btnDraftLoading: _ctx.btnDraftLoading,
              btnReadyLoading: _ctx.btnReadyLoading,
              inputText: _ctx.inputText,
              isChatCreateUserMe: _ctx.isChatCreateUserMe
            }, null, 8, ["onSaveDraft", "onSaveSendReady", "onSendMessage", "btnSendLoading", "btnDraftLoading", "btnReadyLoading", "inputText", "isChatCreateUserMe"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_component_VueLoading, { height: '50vh' })
        ])),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogSelectChild,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogSelectChild) = $event)),
      width: "280px",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "selectItemList pb-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.selectedClass,
                  "onUpdate:modelValue": [
                    _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedClass) = $event)),
                    _ctx.selectChildItems
                  ],
                  items: _ctx.classList,
                  "item-title": "className",
                  "item-value": "classId",
                  variant: "filled",
                  "hide-details": "",
                  "return-object": "",
                  color: "rgb(105,105,105)"
                }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, {
              style: {"height":"40vh"},
              class: "childList"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childList, (c, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: index,
                        onClick: ($event: any) => (_ctx.toClassChildren(c))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_content, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(c.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dialog) = $event)),
      class: "comment-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "headline lighten-2" }),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_v_btn, {
                class: "flex justify-space-around",
                color: "primary",
                variant: "outlined",
                width: "48%",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onClickAbsencedeleteDialog()))
              }, {
                default: _withCtx(() => [
                  _cache[38] || (_cache[38] = _createElementVNode("div", { class: "text-overline font-weight-bold" }, "欠席確認・削除へ", -1)),
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                class: "flex justify-space-around",
                color: "primary",
                variant: "outlined",
                width: "48%",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.absenceRegistDialog = true))
              }, {
                default: _withCtx(() => [
                  _cache[40] || (_cache[40] = _createElementVNode("div", { class: "text-overline font-weight-bold" }, "欠席登録へ", -1)),
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_v_btn, {
                class: "flex justify-space-around",
                color: "primary",
                variant: "flat",
                width: "45%",
                onClick: _ctx.toChildDiary
              }, {
                default: _withCtx(() => [
                  _cache[42] || (_cache[42] = _createElementVNode("div", { class: "text-overline font-weight-bold" }, "本日の記録へ", -1)),
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                class: "flex justify-space-around",
                color: "primary",
                variant: "flat",
                width: "45%",
                to: `/communication/ready-send-box`
              }, {
                default: _withCtx(() => [
                  _cache[44] || (_cache[44] = _createElementVNode("div", { class: "text-overline font-weight-bold" }, "送信準備BOXへ", -1)),
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_v_btn, {
                class: "flexjustify-space-around",
                color: "primary",
                variant: "flat",
                width: "45%",
                to: `/communication/draft`
              }, {
                default: _withCtx(() => [
                  _cache[46] || (_cache[46] = _createElementVNode("div", { class: "text-overline font-weight-bold" }, "下書きへ", -1)),
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                class: "flexjustify-space-around",
                color: "primary",
                variant: "flat",
                width: "45%",
                onClick: _ctx.clickToParentsRecord
              }, {
                default: _withCtx(() => [
                  _cache[48] || (_cache[48] = _createElementVNode("div", { class: "text-overline font-weight-bold" }, "家庭での記録へ", -1)),
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_textarea, {
              variant: "solo",
              flat: "",
              "hide-details": "",
              rows: "1",
              "auto-grow": "",
              name: "comment",
              placeholder: "コメントを入力",
              "prepend-inner-icon": "mdi-note-outline",
              modelValue: _ctx.inputComment,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.inputComment) = $event)),
              clearable: "",
              class: "comment-area",
              style: {"white-space":"pre-wrap"}
            }, null, 8, ["modelValue"]),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "text",
                  onClick: _ctx.saveComment,
                  loading: _ctx.commentLoading
                }, {
                  default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                    _createTextVNode(" 保存 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.deleteDialog,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.deleteDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_v_card_title, { class: "headline lighten-2" }, {
                default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                  _createTextVNode("削除しますか？", -1)
                ]))]),
                _: 1
              })
            ]),
            (_ctx.tempChat.body)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createVNode(_component_v_card_subtitle, {
                    style: {"white-space":"pre-line","user-select":"none"},
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.showLongText(_ctx.tempChat.body)), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[11] || (_cache[11] = () => (_ctx.deleteDialog = false)),
                    variants: "text"
                  }, {
                    default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                      _createTextVNode(" キャンセル ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "error",
                    class: "ml-5",
                    variant: "flat",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deleteChat())),
                    loading: _ctx.deleteLoading
                  }, {
                    default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                      _createTextVNode(" 削除 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.actionDialog,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.actionDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_34, [
              (_ctx.chatType != 'groupChat')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.clickDeleteDialog(_ctx.tempChat)))
                  }, {
                    default: _withCtx(() => [
                      _cache[54] || (_cache[54] = _createElementVNode("span", null, "削除", -1)),
                      _createVNode(_component_v_icon, { right: "" }, {
                        default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                          _createTextVNode("mdi-trash-can-outline", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, { onClick: _ctx.onCopyTextCopy }, {
                default: _withCtx(() => [
                  _cache[56] || (_cache[56] = _createElementVNode("span", null, "コピー", -1)),
                  _createVNode(_component_v_icon, { right: "" }, {
                    default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                      _createTextVNode("mdi-content-copy", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isTranslationDialog,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isTranslationDialog) = $event)),
      persistent: "",
      "max-width": "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TranslationModal, {
          isOpen: _ctx.isTranslationDialog,
          childId: _ctx.childId,
          selectedChat: _ctx.translationChat,
          onTranslate: _ctx.onTranslated,
          onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isTranslationDialog = false))
        }, null, 8, ["isOpen", "childId", "selectedChat", "onTranslate"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.absenceRegistDialog,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.absenceRegistDialog) = $event)),
      fullscreen: "",
      "hide-overlay": "",
      transition: "dialog-bottom-transition",
      class: "absence-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AbsenceModal, {
          isOpen: _ctx.absenceRegistDialog,
          childId: _ctx.childId,
          date: _ctx.date,
          nurseryId: _ctx.nurseryId,
          onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.absenceRegistDialog = false)),
          onPosted: _ctx.createAbsence
        }, null, 8, ["isOpen", "childId", "date", "nurseryId", "onPosted"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.absencedeleteDialog,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.absencedeleteDialog) = $event)),
      fullscreen: "",
      "hide-overlay": "",
      transition: "dialog-bottom-transition",
      class: "absence-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AbsenceDeleteModal, {
          chatsAbsence: _ctx.chatsAbsence,
          childId: _ctx.childId,
          date: _ctx.date,
          nurseryId: _ctx.nurseryId,
          onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.absencedeleteDialog = false)),
          onPosted: _ctx.deleteAbsence
        }, null, 8, ["chatsAbsence", "childId", "date", "nurseryId", "onPosted"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      class: "pt-5",
      modelValue: _ctx.isAttachmentUrls,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.isAttachmentUrls) = $event)),
      fullscreen: "",
      "hide-overlay": "",
      transition: "dialog-bottom-transition"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pdf_wrapper pt-5" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_v_toolbar, {
                class: "pdf_header",
                dark: "",
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    icon: "",
                    dark: "",
                    onClick: _ctx.closeChatImg,
                    absolute: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_spacer)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_36, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showingUrls, (u) => {
                return (_openBlock(), _createElementBlock("div", { key: u }, [
                  (u.indexOf('.pdf?') >= 0)
                    ? (_openBlock(), _createElementBlock("object", {
                        key: 0,
                        data: u,
                        type: "application/pdf",
                        width: "100%",
                        height: "100%"
                      }, [
                        _createElementVNode("iframe", {
                          src: u,
                          width: "100%",
                          height: "100%"
                        }, [
                          _createElementVNode("p", null, [
                            _cache[58] || (_cache[58] = _createElementVNode("b", null, "表示されない時の表示", -1)),
                            _cache[59] || (_cache[59] = _createTextVNode(": ", -1)),
                            _createElementVNode("a", { href: u }, "PDF をダウンロード", 8, _hoisted_39),
                            _cache[60] || (_cache[60] = _createTextVNode(".", -1))
                          ])
                        ], 8, _hoisted_38)
                      ], 8, _hoisted_37))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        style: {"width":"100%"},
                        src: u
                      }, null, 8, _hoisted_40))
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dateDialogFlg,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.dateDialogFlg) = $event)),
      width: "auto"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_locale_provider, { locale: "ja" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_date_picker, {
              modelValue: _ctx.selectedDate,
              "onUpdate:modelValue": [
                _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selectedDate) = $event)),
                _ctx.dateSelected
              ],
              type: "date",
              "day-format": (date) => new Date(date).getDate(),
              "no-title": "",
              "hide-header": "",
              color: "primary",
              style: {"transform":"scale(0.8)"}
            }, null, 8, ["modelValue", "day-format", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.snackbar) = $event)),
      timeout: _ctx.timeout,
      outlined: "",
      top: "",
      color: "primary"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          color: "ourline-primary",
          variant: "text",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.snackbar = false))
        }, {
          default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
            _createTextVNode(" × ", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.snackBarText) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "timeout"])
  ]))
}